import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'

import { useNavigate } from 'react-router-dom'

import BackEndAPI from '../../../Services/BackEndAPI'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import TextArea from '../../../DevComponents/TextArea'
import ComboBox from '../../../DevComponents/ComboBox'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import { TipoRHInterface, TipoRHType, TipoRHTypes } from '../../../ImportBackend/types/ConstantesDataTypes'
import { FatorRHSQLInterface } from '../../../ImportBackend/Interfaces/FatorRHInterfaces'
import { clsUtils } from 'zlib-utils'
import Condicional from '../../../Layout/Condicional'

export default function FatorRHCadastroSQL() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const navigate = useNavigate()

  const ResetDados: FatorRHSQLInterface = {
    tipoRH: TipoRHType.SEM_ACESSO,
    sqlAdmissao: '',
    sqlAfastamento: '',
    sqlDemissao: ''
  }

  const [dados, setDados] = useState<typeof ResetDados>({ ...ResetDados })
  const [conteudoOriginal, setConteudoOriginal] = useState<FatorRHSQLInterface>({ ...ResetDados })

  const clsApi: BackEndAPI = new BackEndAPI()

  const onChangeTipoRH = (rs: TipoRHInterface) => {

    if (rs && rs.idTipoRH.length > 0 && rs.idTipoRH !== TipoRHType.SEM_ACESSO) {

      const query = `
        getFatorRHSql (tipoRH: "${rs.idTipoRH}") {
          tipoRH
          sqlAfastamento
          sqlAdmissao
          sqlDemissao
        }
      `

      clsApi.query<FatorRHSQLInterface>(query, 'getFatorRHSql', 'Consultando SQL...', contexto).then(rsSQL => {

        setDados(rsSQL)
        setConteudoOriginal(rsSQL)

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao consultar SQL do Fator RH!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })


    } else {
      setDados(ResetDados)
    }

  }

  const onGravarSQL = () => {

    if (dados && dados.tipoRH.length > 0) {

      const mutation = `
        updateFatorRHSql (dados: ${clsUtils.ConverterEmGql(dados)}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'updateFatorRHSql', 'Atualizando SQL...', contexto).then(rs => {

        if (!rs.ok) {
          setMensagemState({
            ...mensagemState,
            titulo: 'Erro ao atualizar SQL do Fator RH!',
            exibir: true,
            mensagem: rs.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          })

        } else {
          setConteudoOriginal(dados)
        }


      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao atualizar SQL do Fator RH!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  return (

    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Cadastro SQL Fator RH
                <Typography variant="body2" gutterBottom>
                  Cadastro do SQL para geração do Fator RH por tipo de RH
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <ComboBox
                campoID='idTipoRH'
                campoDescricao='descricao'
                opcoes={TipoRHTypes}
                dados={dados}
                field='tipoRH'
                setState={setDados}
                label='Sistema RH'
                onChange={(rs: TipoRHInterface) => onChangeTipoRH(rs)}
              />


            </Grid>

            <Grid item xs={12}>

              <Box sx={{ width: '100%' }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={rsTab} onChange={changeRsTab} aria-label="drg envio tabs">
                    <Tab label="Admissão" />
                    <Tab label="Afastamento" />
                    <Tab label="Demissão" />
                  </Tabs>
                </Box>

                <Condicional condicao={rsTab === 0}>
                  <TextArea
                    dados={dados}
                    field='sqlAdmissao'
                    label='SQL Admissão'
                    setState={setDados}
                    height='300px'
                    disabled={dados && dados.tipoRH && dados.tipoRH !== TipoRHType.SEM_ACESSO ? false : true}
                  />
                </Condicional>

                <Condicional condicao={rsTab === 1}>
                  <TextArea
                    dados={dados}
                    field='sqlAfastamento'
                    label='SQL Afastamento'
                    setState={setDados}
                    height='300px'
                    disabled={dados && dados.tipoRH && dados.tipoRH !== TipoRHType.SEM_ACESSO ? false : true}
                  />
                </Condicional>

                <Condicional condicao={rsTab === 2}>
                  <TextArea
                    dados={dados}
                    field='sqlDemissao'
                    label='SQL Demissão'
                    setState={setDados}
                    height='300px'
                    disabled={dados && dados.tipoRH && dados.tipoRH !== TipoRHType.SEM_ACESSO ? false : true}
                  />
                </Condicional>

              </Box>

            </Grid>

            <Grid item xs={12} sx={{ mt: 1, textAlign: 'right' }} >
              <Button disabled={dados && dados.tipoRH && dados.tipoRH !== TipoRHType.SEM_ACESSO && JSON.stringify(dados) !== JSON.stringify(conteudoOriginal) ? false : true} variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onGravarSQL()}>Gravar</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>

  )
}